<template>
  <div
    ref="modelOffersContainer"
    class="model-offers"
    itemprop="offers"
    :itemscope="undefined"
    itemtype="http://schema.org/AggregateOffer"
  >
    <template v-if="model.price_info && offerCount">
      <meta itemprop="lowPrice" :content="String(model.price_info.min)" />
      <meta itemprop="highPrice" :content="String(model.price_info.max)" />
      <meta itemprop="priceCurrency" content="RUB" />
      <meta itemprop="offerCount" :content="String(offerCount)" />
    </template>
    <h2 class="header heading-m">
      Цены на {{ model.brand.name || '' }} {{ model.name }} в г.
      {{ isRegion }}
    </h2>
    <form
      ref="formFilters"
      class="filters-wrap sticky-container-top"
      novalidate
    >
      <div class="filter-header" @click.stop>
        <div class="header-controls">
          <div class="header-filters">
            <FiltersFiltersButtonModel
              v-if="isFiltersButtons"
              class="filter-item"
              :visible="true"
              :count="buttonFiltersCount"
              @click="setFiltersModal(true)"
            />
            <UiButtonToggle
              v-if="showBestPrice"
              class="filter-item"
              :gradient-border="true"
              :title="filters?.best_price?.name || ''"
              :value="filtersSettings.best_price"
              @change-toggle="changeToggleBestPrice"
            />
            <UiPSelect
              class="filter-item sort-select"
              :list="sortList"
              :value="sort.value"
              value-param="value"
              select-style="text"
              :list-width="232"
              placeholder="Сортировка"
              @change="changeSort"
            />
            <UiButtonToggle
              v-if="showDiscount"
              class="filter-item"
              title="Скидка"
              :value="filtersSettings.discount"
              @change-toggle="changeToggleDiscount"
            />
            <template v-for="(item, index) in firstFilters">
              <UiFilterEnum
                v-if="
                  isEnum(index, item.type, item.allowed_values) &&
                  getValueFiltersSettings(item)
                "
                :key="`enum ${index.toString()}`"
                class="filter-item"
                :settings="item"
                :set-filters="setFilters"
                :value="getValueFiltersSettings(item)"
                @on-enum-change="filtersChange"
                @set-filters="
                  getWithNewFilters();
                  sendYa();
                "
              />

              <UiFilterRange
                v-else-if="
                  item.type === 'RANGE' && getValueFiltersSettings(item)
                "
                :key="`range ${index.toString()}`"
                class="filter-item"
                :settings="item"
                :set-filters="setFilters"
                :value="getValueFiltersSettings(item)"
                @on-range-change="filtersChange"
                @set-filters="
                  getWithNewFilters();
                  sendYa();
                "
              />

              <UiButtonToggle
                v-else-if="item.type === 'BOOL'"
                :id="item.id"
                :key="`bool ${index.toString()}`"
                class="filter-item"
                :title="item.name"
                :value="getValueFiltersSettings(item)"
                @on-boolean-change="filtersChange"
                @set-filters="getWithNewFilters()"
              />
            </template>
          </div>
        </div>
      </div>
      <UiModal
        v-if="filtersModal"
        modal-styles="filters-modal"
        @close="setFiltersModal(false)"
      >
        <PerfectScrollbar
          class="filters"
          :options="{ wheelPropagation: false }"
          @click.stop
        >
          <div class="header-tablet">
            <div class="heading-m">Все фильтры</div>
            <button
              :disabled="isDisabledReset"
              class="text-button"
              :class="{ 'button-disabled': isDisabledReset }"
              type="button"
              @click="clearFilters()"
            >
              Сбросить
            </button>
          </div>
          <div
            v-if="showBestPrice"
            class="filter-wrap filter-wrap-toggle filter-wrap--best-price"
          >
            <UiButtonToggle
              class="filter-body"
              gradient-border
              responsive
              :title="filters?.best_price?.name || ''"
              :value="filtersSettings.best_price"
              @change-toggle="changeToggleBestPrice"
            />
          </div>
          <div v-if="showDiscount" class="filter-wrap filter-wrap-toggle">
            <UiButtonToggle
              class="filter-body"
              title="Скидка"
              responsive
              :value="filtersSettings.discount"
              @change-toggle="changeFilterModalDiscount"
            />
          </div>
          <template v-for="(item, index) in filters?.filters">
            <div
              v-if="isShowModalFilter(item)"
              :key="item.id"
              class="filter-wrap"
            >
              <UiSlideDown
                :open="true"
                class="filter"
                :class="{ 'no-border': index === 0 }"
                @change="$emit('update:position', null)"
              >
                <template #header="{ visible }">
                  <div
                    class="filter-header"
                    :class="{
                      'filter-header__no-active': isAllNotActive(item),
                    }"
                  >
                    <div class="filter-title">
                      {{ item.name }}{{ item?.unit ? ', ' + item?.unit : '' }}
                    </div>
                    <div class="is-body-opened" :class="{ closed: !visible }" />
                  </div>
                </template>
                <template #default="{ calcStyle }">
                  <component
                    :is="getFilterComponentByType(item.type)"
                    class="filter-body"
                    :settings="item"
                    :value="getValueFiltersSettings(item)"
                    emit-position
                    @on-change="filtersChange"
                    @show="calcStyle"
                    @position="onPositionChange"
                  />
                </template>
              </UiSlideDown>
            </div>
          </template>
        </PerfectScrollbar>
        <div class="filters-get-wrap">
          <ModelOffersFiltersGetModal
            :loading="filtersCountLoading"
            :count="filtersCount"
            @get-filters="getNewProducts()"
          />
        </div>
      </UiModal>
    </form>
    <div v-if="isOffers" ref="offersElement" class="offer-list">
      <ModalsPromocodeShopModal
        v-if="showPromocodeModal"
        :shop="shopModalInfo"
        :model="model"
        @close="closePromocodeModal"
      />
      <ProductCardPrice
        v-for="(item, index) in offers?.list"
        :id="`offer_${item.id}`"
        :key="`${item.id}_${index}`"
        :highlight-offer="highlightOffer === String(item.id)"
        :model="item"
        :position="itemsOffset + index"
        block-type="model-offers"
        @show-promocode-modal="openPromocodeModal"
        @open-monitoring-sticker-modal="
          $emit('openMonitoringStickerModal', item)
        "
      />
      <div
        v-if="pageCount > 1"
        class="offers-footer"
        :class="{ 'without-show-all': !showAll }"
      >
        <UiPagination
          :page-count="pageCount"
          :active="pageActive"
          :disabled="!!loading"
          :wide="!showAll"
          @on-page-change="changePage"
        />
      </div>
    </div>
    <div v-else class="not-found">Предложений не найдено</div>
    <div v-if="isShowNoOffers" class="no-offers">
      <div class="no-offers__icon_wrap">
        <div class="no-offers__icon" />
      </div>
      <div>
        <div class="no-offers__title">{{ noOffersTitle }}</div>
        <div class="no-offers__content">
          <p>
            Не&nbsp;нашли подходящее предложение? В&nbsp;ряде московских
            магазинов есть доставка по&nbsp;РФ.
          </p>
          <p>
            Чтобы увидеть их&nbsp;предложения и&nbsp;найти подходящее,
            переключите город на&nbsp;Москву.
          </p>
          <p>
            Проверяйте условия доставки у&nbsp;продавца и&nbsp;не&nbsp;забудьте
            вернуть свой регион, чтобы продолжить искать товары на&nbsp;Price.
          </p>
        </div>
        <ui-ui-button class="no-offers__button" @click="setMoscow">
          Переключить город на Москву
        </ui-ui-button>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type {
  ResponseModelOffers,
  ResponseCategoryFilters,
  ResponseModel,
  OfferModel,
  OfferFilter,
  BooleanFilter,
  ModelCoupon,
  RequestParams,
} from '~/interfaces/api';
import { maxAge, sortListings } from '~/common/const';
import { defaultRegion, useGlobalStore } from '~/stores/global';
import { useAnalyticsStore } from '~/stores/analytics';
import { useFilters } from '~/composition/useFilters';
import { API } from '~/api/api';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { getModelsOffersList } from '~/api/global';
import numWord from '~/common/num-word';
import { hostData } from '~/utils/urlHelpers';
import type { ActiveFilter, PostBodyFilters } from '~/interfaces/app';
import { getAnyPostData } from '~/api/pageCategoryList';
import { mergeFilters } from '~/utils/mergeFilters';
import { fixBoolFilters } from '~/utils/fixBoolFilters';

const { $ymAnyEvent, $ymClickSortEvent } = useNuxtApp();

const mockEmptyOffer: OfferModel = {
  type: 'skeleton',
  id: 0,
  name: '',
  photo: '',
  click_url: '',
  price: 0,
  pickup: {
    description: '',
    cost: 0,
    fixed: false,
    options: [
      {
        cost: 0,
        order_before: 0,
        days: '',
      },
    ],
  },
  description: '',
  discount: null,
  cpo: false,
  model_id: null,
  image: '',
  delivery: {
    description: '',
    cost: 0,
    fixed: false,
    options: [
      {
        cost: 0,
        order_before: 0,
        days: '',
      },
    ],
  },
  shop_info: {
    id: 0,
    name: '',
    site: '',
    logo: '',
    coupon: {},
  },
  modification_attributes: '',
  modification_attributes_desc: [],
};

function setEmptyOffersMock(n: number, total = 1): ResponseModelOffers {
  const emptyOffers: ResponseModelOffers = {
    list: [],
    categories: [],
    page: 1,
    per_page: 1,
    total,
  };
  for (let i = 1; i <= n; i++)
    emptyOffers.list.push({ ...mockEmptyOffer, id: i });

  return emptyOffers;
}

function wordEnd(val: number) {
  return numWord(val, ['', 'предложение', 'предложения', 'предложений'], true);
}

const emit = defineEmits([
  'change-data',
  'change-model-sort-top3',
  'set-filter',
  'update:position',
  'toRoute',
  'click',
  'openMonitoringStickerModal',
]);
const props = defineProps({
  model: {
    type: Object as () => ResponseModel,
    required: true,
  },
  perPage: {
    type: Number,
    required: true,
  },
  offerFilters: Object as () => ResponseCategoryFilters,
  offers: {
    type: Object as () => ResponseModelOffers,
    required: true,
  },
  showAll: {
    type: Boolean,
    default: false,
  },
  changedPage: Boolean,
});

const globalStore = useGlobalStore();
const mediaStore = useMediaQueryStore();
const analyticsStore = useAnalyticsStore();

const route = useRoute();
const router = useRouter();

const ENUM = resolveComponent('filters-enum-filter-listings');
const RANGE = resolveComponent('filters-range-input');
const BOOL = resolveComponent('filters-boolean-filter');

const setFilters = ref('');
const filtersModal = ref(false);
const formFilters = ref<HTMLElement>();
const sort = ref({
  value: route.query['products-sort'] || sortListings[0].value,
});
const offersElement = ref<HTMLElement>();
const modelOffersContainer = ref<HTMLElement>();
const pageActive = ref<number>(props.offers?.page || 1);
const loading = ref(false);
const showDiscount = ref(false);
const showBestPrice = ref(false);
const filtersCount = ref<number>(props.offers?.total || 0);
const initialCount = ref<number>(props.offers?.total || 0);
const readyFiltersCount = ref<number>(props.offers?.total || 0);
const filtersCountLoading = ref(false);
const showPromocodeModal = ref(false);
const shopModalInfo = ref(null);
const offersMoscowCount = ref(0);
const saveFilters = ref(props.offerFilters?.filters);
const lastActiveFilters = ref<ActiveFilter[]>([]);

const isMobile = computed(
  () =>
    mediaStore.isMobile ||
    mediaStore.isLessEs ||
    mediaStore.isEs ||
    mediaStore.isSm ||
    mediaStore.isMd
);
const highlightOffer = computed(() => props.model?.highlightOffer || '');
const firstFilters = computed(() => {
  const list = props.offerFilters?.filters || [];
  const { first, others } = list.reduce(
    (acc, item) => {
      if (item?.main || item.name === 'Цвет') {
        acc.first.push(item);
      } else {
        acc.others.push(item);
      }
      return acc;
    },
    { first: [], others: [] }
  );
  return [...first, ...others];
});
const pageCount = computed(() =>
  Math.ceil((readyFiltersCount.value || 0) / props.perPage)
);
const offerCount = computed(() => props.model?.offer_count || 0);
const isOffers = computed<boolean>(() => !!props.offers?.list?.length);
const sortList = computed(() =>
  sortListings.slice(0, showDiscount.value ? 4 : 3)
);
const itemsOffset = computed(
  (): number => (pageActive.value - 1) * props.perPage + 1
);
const filters = computed<ResponseCategoryFilters>(
  () => props.offerFilters || { filters: [], count: 0 }
);
const isDisabledReset = computed(() => {
  if (
    filtersSettings.value.active &&
    filtersSettings.value.active.filter((item) => item.filter !== 'price')
      .length
  )
    return false;
  return !atLeastOne.value || !isChanged.value;
});
const isRegion = computed(() => globalStore?.region?.name);
const isShowNoOffers = computed(
  () => globalStore?.region?.id !== 1 && offersMoscowCount.value > 3
);
const noOffersTitle = computed(
  () => `Есть ещё ${wordEnd(offersMoscowCount.value)} в Москве`
);

const {
  values: filtersSettings,
  initiateFilters,
  getFiltersForRequest,
  formatFiltersForRequest,
  filtersChange,
  clearFilters,
  getWithNewFilters,
  isChanged,
  atLeastOne,
  filtersQuery,
} = useFilters(filters, getCount, getOffers, true);

if (!props.offerFilters && props.changedPage)
  getFilters().then(() => {
    pageActive.value = 1;
    initiateFilters();
    getOffers(true, true);
  });

if (!props.offers && props.perPage)
  emit('change-data', {
    key: 'offers',
    data: setEmptyOffersMock(props.perPage),
  });

if (
  props.offerFilters &&
  props.changedPage &&
  (!props.offers || (props.offers.per_page || props.perPage) !== props.perPage)
) {
  pageActive.value = 1;
  initiateFilters();
  getOffers(true, true);
}

function getFilterComponentByType(type: string) {
  if (type === 'ENUM') return ENUM;
  if (type === 'RANGE') return RANGE;
  if (type === 'BOOL') return BOOL;
  return '<div>Ошибка типа фильтра</div>';
}

async function getFilters() {
  if (!props.model?.id) return null;
  return await API.post(`/models/${props.model.id}/filters`, null, {
    params: {
      region_id: globalStore?.region?.id || '1',
      sem: globalStore?.sem || undefined,
      device: globalStore?.device || undefined,
      split: analyticsStore?.additional?.split || 'b',
      all: globalStore?.debugPanelAll,
    },
  })
    .then((res) => {
      const rData = res.data;
      if ('filters' in rData && rData.filters)
        rData.filters = fixBoolFilters(rData.filters);
      const addActive = (filtersArr: OfferFilter[]) =>
        filtersArr.map((item) => ({ ...item, active: true }));
      const setData = {
        ...rData,
      };
      if ('brands' in setData && Array.isArray(setData.brands)) {
        setData.brands = addActive(setData.brands);
      }
      if ('filters' in setData && Array.isArray(setData.filters)) {
        setData.filters = setData.filters.map((item: BooleanFilter) => {
          if (item.type === 'RANGE' || item.type === 'BOOL')
            return { ...item, active: true };
          if (item?.allowed_values)
            return {
              ...item,
              allowed_values: addActive(item.allowed_values),
            };
          return item;
        });
      }
      emit('change-data', {
        key: 'filters',
        data: setData,
      });
    })
    .catch(() =>
      emit('change-data', {
        key: 'filters',
        data: { filters: [] },
      })
    );
}

async function getCount(): Promise<any> {
  if (!isMobile.value || !props.model?.id) return;
  filtersCountLoading.value = true;
  const params = {
    region_id: globalStore?.region?.id || '1',
    page: 1,
    per_page: 1,
    device: globalStore?.device || undefined,
  };
  const reqBody: PostBodyFilters = formatFiltersForRequest();
  return await getModelsOffersList(props.model.id, reqBody, params)
    .then((val) => (filtersCount.value = val?.offer_count || 0))
    .finally(() => (filtersCountLoading.value = false));
}

async function getOffers(
  loadFirst = false,
  newFilters = false,
  withoutBody = false
): Promise<any> {
  const params = {
    region_id: globalStore?.region?.id || '1',
    sort: sort.value.value,
    page: loadFirst ? 1 : pageActive.value,
    per_page: props.perPage,
    sem: globalStore?.sem || undefined,
    device: globalStore?.device || undefined,
    split: analyticsStore?.additional?.split,
    all: globalStore?.debugPanelAll || undefined,
  };
  const reqBody: PostBodyFilters = withoutBody
    ? null
    : getFiltersForRequest(newFilters);
  loading.value = true;
  if (!props.perPage || !props.model?.id) return;
  emit('change-data', {
    key: 'offers',
    data: setEmptyOffersMock(props.perPage, props.offers?.total || 1),
  });
  await getModelsOffersList(props.model.id, reqBody, params)
    .then((res) => {
      const rData = res;
      emit('change-data', {
        key: 'offers',
        data: rData,
      });
      if (res) {
        const { total, page } = rData;
        filtersCount.value = total;
        readyFiltersCount.value = total;
        pageActive.value = page;
      }
    })
    .catch(() => {
      emit('change-data', {
        key: 'offers',
        data: null,
      });
    })
    .finally(async () => {
      setFilters.value = new Date().toString();
      await getActiveFilters(reqBody, params);
      loading.value = false;
    });
}

async function getActiveFilters(
  reqBody: PostBodyFilters,
  params: RequestParams
) {
  if (
    !filtersSettings.value.active ||
    filtersSettings.value.active?.length === 0
  ) {
    lastActiveFilters.value = [];
    emit('change-data', {
      key: 'filters',
      data: saveFilters.value,
    });
    setTimeout(() => {
      if (saveFilters.value) {
        initiateFilters(false, filters.value);
      }
    });
    return;
  }
  const activeFiltersData = await getAnyPostData<any>(
    `/models/${props.model?.id}/filters`,
    reqBody,
    {
      params: { ...params, check_offers: true },
    }
  );
  if ('filters' in activeFiltersData && activeFiltersData.filters)
    activeFiltersData.filters = fixBoolFilters(activeFiltersData.filters);
  const formatedLastFilters = lastActiveFilters.value.map(
    (i) => `${i.filter}_${i.id}_${i?.item_id || ''}`
  );
  const formatedCurrentFilters = filtersSettings.value.active.map(
    (i) => `${i.filter}_${i.id}_${i?.item_id || ''}`
  );
  // список последних установленных фильтров
  const addedFilters = filtersSettings.value.active.filter((i) => {
    const item = `${i.filter}_${i.id}_${i?.item_id || ''}`;
    return !formatedLastFilters.includes(item);
  });
  const removedFilters = lastActiveFilters.value.filter((i) => {
    const item = `${i.filter}_${i.id}_${i?.item_id || ''}`;
    return !formatedCurrentFilters.includes(item);
  });

  lastActiveFilters.value = filtersSettings.value.active;
  const mergeData = mergeFilters(
    saveFilters.value,
    activeFiltersData,
    [...addedFilters, ...removedFilters],
    filtersSettings.value.active
  );
  emit('change-data', {
    key: 'filters',
    data: mergeData,
  });
  setTimeout(() => {
    initiateFilters(false, mergeData);
  });
}

const isAllNotActive = (item: OfferFilter) => {
  if (item.type !== 'ENUM') {
    return 'active' in item ? !item.active : false;
  } else if (item?.allowed_values && item?.allowed_values.length) {
    return item?.allowed_values.reduce((a: boolean, i) => {
      return 'active' in i && i.active ? false : a;
    }, true);
  }
  return true;
};

async function getMoscowOffers() {
  if (!props.model?.id) {
    offersMoscowCount.value = 0;
    return;
  }
  const params = {
    region_id: '1',
    sort: sort.value.value,
    page: 1,
    per_page: 1,
    sem: globalStore?.sem || undefined,
    device: globalStore?.device || undefined,
    split: analyticsStore?.additional?.split,
    all: globalStore?.debugPanelAll || undefined,
  };
  const data = await getModelsOffersList(props.model.id, null, params);
  offersMoscowCount.value = data?.offer_count || 0;
}

function setMoscow() {
  $ymAnyEvent('reachGoal', 'click_msk_offers');
  const city = defaultRegion;
  const { domain, domainWithPort } = hostData(
    window.location.hostname,
    window.location.port
  );
  const cookieRegion = useCookie('region', {
    path: '/',
    domain,
    maxAge,
  });
  cookieRegion.value = JSON.stringify(city);
  const newLocation = `//${domainWithPort}${window.location.pathname}`;
  globalStore.setRegion(city);
  setTimeout(() => {
    navigateTo(newLocation, {
      external: true,
      redirectCode: 301,
    });
  }, 500);
}

const pageRoute = ref<string>(
  route.path.endsWith('/') ? route.path.slice(0, -1) : route.path
);

function changeSort(val: string): void {
  sort.value.value = val;
  $ymClickSortEvent(val);
  emit('change-model-sort-top3');
  if (router)
    router.replace({
      path: pageRoute.value + '/',
      query: { ...route.query, 'products-sort': sort.value.value },
    });
  getOffers(true, !isChanged.value);
}

function changePage(page: number): void {
  pageActive.value = page;
  const top: number = modelOffersContainer.value?.offsetTop || 30;
  window.scrollTo({
    top: isMobile.value ? top - 30 : top - 40,
  });
  nextTick(() => {
    getOffers(false, !isChanged.value);
  });
}

const sendYa = () => {
  $ymAnyEvent('reachGoal', 'Filtration');
};

function getNewProducts() {
  sendYa();
  getWithNewFilters();
  setFilters.value = new Date().toString();
  setFiltersModal(false);
}

const isFiltersButtons = computed<boolean>(
  () =>
    !!filters.value?.filters?.length &&
    filtersSettings.value.initiated &&
    filters.value?.filters?.length > 3
);

const buttonFiltersCount = computed<number>(() => {
  if (!isFiltersButtons.value || !filtersSettings.value?.active) return 0;
  return (
    filtersSettings.value.active.filter((item) => item.filter !== 'price')
      .length || 0
  );
});

function isEnum(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  index: number,
  type: string,
  allowed_values: string[] | undefined
) {
  const isAllowedValues = allowed_values && allowed_values.length > 0;
  return type === 'ENUM' && isAllowedValues;
}

function getValueFiltersSettings(item: OfferFilter) {
  return filtersSettings.value?.filters[item.id]?.value;
}

function onPositionChange(e: { right: number; top: number }): void {
  if (formFilters.value) {
    const { left, top } = formFilters.value?.getBoundingClientRect();
    emit('update:position', {
      left: e.right - left + 16 + 'px',
      top: e.top - top - window.scrollY + 'px',
    });
  }
}

function isShowModalFilter(item: OfferFilter) {
  const type = item.type || '';
  const allowed_values = item?.allowed_values || [];
  const isAllowedValues = allowed_values && allowed_values.length > 0;
  if (type === 'ENUM') {
    return isAllowedValues;
  }
  return true;
}

function changeToggleDiscount(val: boolean) {
  if (val) {
    $ymAnyEvent('reachGoal', 'filter_best_price');
  }
  filtersChange({ id: '', val, queryVal: 'discount' }, 'discount', false);
  getWithNewFilters();
}

function changeToggleBestPrice(val: boolean) {
  if (val) {
    $ymAnyEvent('reachGoal', 'filter_best_price');
  }
  filtersChange({ id: '', val, queryVal: 'best_price' }, 'best_price', false);
  getWithNewFilters();
}

function changeFilterModalDiscount(val: boolean) {
  filtersChange({ id: '', val, queryVal: 'discount' }, 'discount');
}

function changeFilterModalBestPrice(val: boolean) {
  filtersChange({ id: '', val, queryVal: 'best_price' }, 'best_price');
}

const firstInitFilters = async () => {
  if (!filters.value?.count || !props.offers) {
    await getFilters();
    pageActive.value = 1;
  }
  initiateFilters(false, filters.value);
  if (props.model?.id) {
    emit('set-filter', filtersQuery.value);
  }
};

function setFiltersModal(value: boolean) {
  filtersModal.value = value;
  emit('click');
}

const openPromocodeModal = (v: ModelCoupon) => {
  shopModalInfo.value = v;
  showPromocodeModal.value = true;
};
const closePromocodeModal = () => {
  shopModalInfo.value = null;
  showPromocodeModal.value = false;
};
onMounted(async () => {
  if (globalStore?.region?.id !== 1 && initialCount.value <= 3) {
    getMoscowOffers();
  }
  await firstInitFilters();
  if (props.offerFilters) {
    // @ts-ignore
    saveFilters.value = props.offerFilters;
  }

  const reqFiltersBody = getFiltersForRequest(true);
  if (
    reqFiltersBody?.price ||
    reqFiltersBody?.discount ||
    reqFiltersBody?.best_price ||
    reqFiltersBody?.brand_id ||
    (reqFiltersBody?.filters && reqFiltersBody?.filters.length)
  ) {
    const params = {
      region_id: globalStore?.region?.id || '1',
      sort: sort.value.value,
      page: 1,
      per_page: props.perPage,
      sem: globalStore?.sem || undefined,
      device: globalStore?.device || undefined,
      split: analyticsStore?.additional?.split,
      all: globalStore?.debugPanelAll || undefined,
    };
    getActiveFilters(reqFiltersBody, params);
  }
  showDiscount.value = !!filters.value?.discount;
  showBestPrice.value = !!filters.value?.best_price?.filter;
});
watch(
  () => filtersQuery.value,
  () => emit('set-filter', filtersQuery.value)
);
</script>

<style scoped lang="scss" src="./ModelOffersScss.scss"></style>
